module.exports = "<app-export isMultipleExport=\"true\" [agents]=\"[]\" [useList]=\"true\" [List]=\"sites\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/intelcia-tree/export-dialog/export-dialog.component.html
// module id = ./src/app/view/intelcia-tree/export-dialog/export-dialog.component.html
// module chunks = main